import { Tooltip } from "@mui/material";
import { useJogs } from "../../../hooks/jogs";

type JogNamesTooltipProps = {
  contentOnly?: boolean;
  label?: string;
  jogIds: undefined | string | string[];
};

export const JogsNamesTooltip = (props: JogNamesTooltipProps): JSX.Element => {
  const jogs = useJogs();
  const Content = (props: JogNamesTooltipProps): JSX.Element => {
    const label = props.label ? props.label + ": " : "";
    const none = `${label}None`;

    const jogIds = NoneOrArray(props.jogIds, props.label);
    if (!Array.isArray(jogIds)) return jogIds as JSX.Element;

    const jogNames = jogs.getNames(jogIds, true);

    // Check length after filtering blanks and "Other"
    if (!jogNames.length) return <>{none}</>;

    if (jogNames.length === 1)
      return (
        <>
          {label}
          {jogNames[0]}
        </>
      );

    return (
      <>
        {props.label ? (
          <>
            {props.label + "s"}
            <br />
          </>
        ) : null}

        <ul style={{ margin: "auto", padding: "auto" }}>
          {jogNames.map((n) => (
            <li key={n}>{n}</li>
          ))}
        </ul>
      </>
    );
  };

  return props.contentOnly ? (
    <Content {...props} />
  ) : (
    <span style={{ whiteSpace: "pre-line" }}>
      <Content {...props} />
    </span>
  );
};

type JogNamesProps = {
  delimiter?: string;
  jogIds: undefined | string | string[];
  maxJogDisplayCount?: number;
  tooltipLabel?: string;
};

const NoneOrArray = (jogIds: undefined | string | string[], label = ""): JSX.Element | string[] => {
  if(!jogIds) return <></>;

  label = label ? label + ": " : "";
  const none = `${label}None`;

  if (!jogIds) return <>{none}</>;

  // if string, change to array
  if (typeof jogIds === "string") {
    jogIds = jogIds.split(",");
  }

  return jogIds;
}

export const JogNames = (props: JogNamesProps): JSX.Element => {
  const jogs = useJogs();
  const none = "None";
  const maxCount = props.maxJogDisplayCount ?? 1000;

  const jogIds = NoneOrArray(props.jogIds);
  if (!Array.isArray(jogIds)) return jogIds as JSX.Element;

  const jogNames = jogs.getNames(jogIds);

  // Check length after filtering blanks and "Other"
  if (!jogNames.length) return <>{none}</>;

  return (
    <Tooltip title={<JogsNamesTooltip label={props.tooltipLabel} jogIds={jogIds} />} arrow followCursor>
      <span>
        {jogNames.slice(0, maxCount).map((name, index) => {
          const appendDelimiter = index < maxCount - 1 && index < jogNames.length - 1;
          return (
            <span key={name}>
              {name}
              {appendDelimiter ? props.delimiter || ", " : ""}
            </span>
          );
        })}
        {jogNames.length > maxCount && <span> & {jogNames.length - maxCount} more...</span>}
      </span>
    </Tooltip>
  );
};
